module.exports = __webpack_public_path__ + "dist/img/biznis-logo.904a84c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/biznis-logo.png
// module id = nb8T
// module chunks = 1